import React, { useEffect, useRef, useState } from "react";
import { BsX, BsClipboard, BsClipboardCheck } from "react-icons/bs";
import { useTranslation } from "react-i18next";

import ConstData from "../../../lib/ConstData";

import Alerts from "../../etc/list/Alerts";

// 20260906 URL 복사 후 아이콘 체크 표시와 알림 메시지가 같은 시간(3초)에 사라지도록 통일
const COPY_FEEDBACK_DURATION_MS = 3000;

const ConfigLocalLive = ({ selectedLiveInfo_liveSeq, selectedLiveInfo_mixedClassExistYn, selectedLiveInfo_mixedClassSeq, selectedLiveInfo, serverUserSeq, alertKind, alertMessage, handleSelectedConfigFunc, getClassMonitorUse, updateClassMonitorUse }) => {
    const { t } = useTranslation();

    const [lAlertKind, setAlertKind] = useState(alertKind);
    const [lAlertMessage, setAlertMessage] = useState(alertMessage);

    const [lLiveName, setLiveName] = useState(selectedLiveInfo.liveName);
    const [lStatus, setStatus] = useState((selectedLiveInfo.mixedClassExistYn === undefined || selectedLiveInfo.mixedClassExistYn === "N") ? false : true);
    const [classMonitorUseYN, setClassMonitorUseYN] = useState("N");
    const [isClassMonitorLoading, setIsClassMonitorLoading] = useState(true);
    const [isClassMonitorAvailable, setIsClassMonitorAvailable] = useState(false);
    // 20260904 URL 복사 버튼 상태: 방금 복사한 URL의 key를 잠깐 저장해 아이콘을 체크로 표시
    const [copiedKey, setCopiedKey] = useState(null);
    const copyTimerRef = useRef(null);
    // 20260905 복사 성공/실패 알림을 일정 시간 후 자동으로 닫기 위한 타이머
    const alertTimerRef = useRef(null);
    //const [lPublicYn, setPulicYn] = useState(selectedLiveInfo.livePublicYn === undefined ? "N" : selectedLiveInfo.livePublicYn);

    useEffect(() => {
        // 20260905 부모가 알림을 새로 지정하면, 대기 중이던 복사 알림 자동 닫힘 타이머는 취소한다.
        if (alertTimerRef.current) {
            clearTimeout(alertTimerRef.current);
            alertTimerRef.current = null;
        }
        setAlertKind(alertKind);
        setAlertMessage(alertMessage);
    }, [alertKind, alertMessage]);

    useEffect(() => {
        // handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ" });
        /* if (selectedLiveInfo) {
            if (selectedLiveInfo.mixedClassExistYn === "Y" && selectedLiveInfo.mixedClassSeq >= 0 && selectedLiveInfo.liveSeq >= 0) {
                console.log("case - update_mixed_class_seq y");
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: selectedLiveInfo.mixedClassSeq });
            } else if (selectedLiveInfo.mixedClassExistYn === "N") {
                console.log("case - update_mixed_class_seq n");
                console.log(" liveSeq - ", selectedLiveInfo.liveSeq);
                console.log(" mixedClassSeq - ", selectedLiveInfo.mixedClassSeq);
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: null });
            } else {
                console.log("update_mixed_class_seq else");
            }
        } */
        /* if (selectedLiveInfo.mixedClassExistYn === "Y" && selectedLiveInfo.mixedClassSeq >= 0 && selectedLiveInfo.liveSeq >= 0) {
            console.log("case - update_mixed_class_seq y");
            handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: selectedLiveInfo.mixedClassSeq });
        } else if (selectedLiveInfo.mixedClassExistYn === "N") {
            console.log("case - update_mixed_class_seq n");
            console.log(" liveSeq - ", selectedLiveInfo.liveSeq);
            console.log(" mixedClassSeq - ", selectedLiveInfo.mixedClassSeq);
            handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: null });
        } else {
            console.log("update_mixed_class_seq else");
        } */

        /* if (selectedLiveInfo_liveSeq >= 0) {
            if (selectedLiveInfo_mixedClassExistYn === "Y") {
                console.log("case - update_mixed_class_seq y");
                console.log("liveSeq - ", selectedLiveInfo_liveSeq);
                console.log("mixedClassSeq - ", selectedLiveInfo_mixedClassSeq);
                if (selectedLiveInfo_mixedClassSeq >= 0) {
                    handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo_liveSeq, mixedClassSeq: selectedLiveInfo_mixedClassSeq });
                } else {
                    console.log("ConfigLocalLive - selectedLiveInfo_mixedClassSeq => ", selectedLiveInfo_mixedClassSeq);
                }
            } else if (selectedLiveInfo_mixedClassExistYn === "N") {
                console.log("case - update_mixed_class_seq n");
                console.log("liveSeq - ", selectedLiveInfo_liveSeq);
                console.log("mixedClassSeq - ", selectedLiveInfo_mixedClassSeq);
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo_liveSeq, mixedClassSeq: null });
            } else {
                console.log("ConfigLocalLive - selectedLiveInfo_mixedClassExistYn => ", selectedLiveInfo_mixedClassExistYn);
            }
        } else {
            console.log("ConfigLocalLive - selectedLiveInfo_liveSeq => ", selectedLiveInfo_liveSeq);
        } */
    }, [selectedLiveInfo_liveSeq, selectedLiveInfo_mixedClassExistYn, selectedLiveInfo_mixedClassSeq]);

    useEffect(() => {
        if (selectedLiveInfo.mixedClassExistYn === "Y") {
            setStatus(true);
        } else {
            setStatus(false);
        }
    }, [selectedLiveInfo.mixedClassExistYn]);

    useEffect(() => {
        let isMounted = true;
        setIsClassMonitorLoading(true);
        setIsClassMonitorAvailable(false);
        // 20260813 기존 클래스 정보와 분리된 신규 API로 클래스 모니터 상태를 조회한다.
        getClassMonitorUse(selectedLiveInfo.liveSeq)
        .then(data => {
            if (isMounted) {
                setClassMonitorUseYN(data.classMonitorUseYN === "Y" ? "Y" : "N");
                setIsClassMonitorAvailable(data.accessAllowed !== false);
                // 20260813 사용 불가 상태는 HTTP 오류 대신 모달 안에서 안내한다.
                if (data.accessAllowed === false) {
                    // 20260905 대기 중인 복사 알림 자동 닫힘 타이머가 이 알림을 지워버리지 않도록 취소
                    if (alertTimerRef.current) { clearTimeout(alertTimerRef.current); alertTimerRef.current = null; }
                    setAlertKind(ConstData.ALERT_KIND.DANGER);
                    setAlertMessage(t(`클래스_모니터_오류_${data.reasonCode}`, { ns: "live" }));
                }
            }
        })
        .catch(error => {
            if (!isMounted) return;
            const reasonCode = error.response && error.response.data && error.response.data.reasonCode;
            // 20260905 대기 중인 복사 알림 자동 닫힘 타이머가 이 알림을 지워버리지 않도록 취소
            if (alertTimerRef.current) { clearTimeout(alertTimerRef.current); alertTimerRef.current = null; }
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(reasonCode ? t(`클래스_모니터_오류_${reasonCode}`, { ns: "live" }) : t("클래스_모니터_상태_조회_실패", { ns: "live" }));
        })
        .finally(() => {
            if (isMounted) setIsClassMonitorLoading(false);
        });
        return () => { isMounted = false; };
    }, [getClassMonitorUse, selectedLiveInfo.liveSeq, t]);

    // 20260904 언마운트 시 복사 아이콘 되돌리기용 타이머 정리
    // 20260905 복사 알림 자동 닫힘 타이머도 함께 정리
    useEffect(() => {
        return () => {
            if (copyTimerRef.current) {
                clearTimeout(copyTimerRef.current);
            }
            if (alertTimerRef.current) {
                clearTimeout(alertTimerRef.current);
            }
        };
    }, []);

    /* useEffect(() => {
        console.log("useEffect - ", selectedLiveInfo.liveSeq, selectedLiveInfo.mixedClassExistYn, selectedLiveInfo.mixedClassSeq);
        if (selectedLiveInfo.mixedClassExistYn === "Y" && selectedLiveInfo.mixedClassSeq >= 0 && selectedLiveInfo.liveSeq >= 0) {
            console.log("case - update_mixed_class_seq y");
            handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: selectedLiveInfo.mixedClassSeq });
        } else if (selectedLiveInfo.mixedClassExistYn === "N") {
            console.log("case - update_mixed_class_seq n");
            console.log(" liveSeq - ", selectedLiveInfo.liveSeq);
            console.log(" mixedClassSeq - ", selectedLiveInfo.mixedClassSeq);
            handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_CLASS_SEQ", liveSeq: selectedLiveInfo.liveSeq, mixedClassSeq: null });
        } else {
            console.log("update_mixed_class_seq else");
        }
    }, [selectedLiveInfo.liveSeq, selectedLiveInfo.mixedClassExistYn, selectedLiveInfo.mixedClassSeq]); */

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    const onChangeMixedClassStatus = (e) => {
        if (serverUserSeq > -1) {
            if (selectedLiveInfo.mixedClassExistYn === "Y") {
                console.log("old mixed class status Y");
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_EXIST_YN", liveSeq: selectedLiveInfo.liveSeq, liveName: selectedLiveInfo.liveName, status: false, mixedClassExistYn: "N" });
            } else {
                console.log("old mixed class status N");
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_EXIST_YN", liveSeq: selectedLiveInfo.liveSeq, liveName: selectedLiveInfo.liveName, status: true, mixedClassExistYn: "Y" });
            }
            // handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_EXIST_YN", liveSeq: selectedLiveInfo.liveSeq, liveName: selectedLiveInfo.liveName, status: selectedLiveInfo.mixedClassExistYn === "Y" ? "N" : "Y" });
        } else {
            handleSelectedConfigFunc({ selectedFunc: "MESSAGE", message: t("클래스_알림_메시지_7", { ns: "live" }) });
        }
    }

    const onChangeLivePublicYn = (e) => {
        // setPulicYn(e.target.value);
        console.log(selectedLiveInfo.livePublicYn);
        handleSelectedConfigFunc({ selectedFunc: "UPDATE_PULIC_YN", liveSeq: selectedLiveInfo.liveSeq, publicYn: selectedLiveInfo.livePublicYn === "Y" ? "N" : "Y" });
    }

    const onChangeClassMonitorUse = () => {
        if (isClassMonitorLoading) return;
        const nextUseYN = classMonitorUseYN === "Y" ? "N" : "Y";
        setIsClassMonitorLoading(true);
        // 20260905 대기 중인 복사 알림 자동 닫힘 타이머가 이후 알림을 지워버리지 않도록 취소
        if (alertTimerRef.current) { clearTimeout(alertTimerRef.current); alertTimerRef.current = null; }
        setAlertKind(ConstData.ALERT_KIND.NONE);
        setAlertMessage("");
        // 20260813 ON은 서비스의 클라우드 허가 검증 성공 후에만 화면 상태를 변경한다.
        updateClassMonitorUse(selectedLiveInfo.liveSeq, nextUseYN)
        .then(data => {
            if (data.isSuccessed && data.isUpdateSuccess) {
                setClassMonitorUseYN(data.classMonitorUseYN === "Y" ? "Y" : "N");
            } else {
                setAlertKind(ConstData.ALERT_KIND.DANGER);
                setAlertMessage(t("클래스_모니터_설정_저장_실패", { ns: "live" }));
            }
        })
        .catch(error => {
            const reasonCode = error.response && error.response.data && error.response.data.reasonCode;
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(reasonCode ? t(`클래스_모니터_오류_${reasonCode}`, { ns: "live" }) : t("클래스_모니터_설정_저장_실패", { ns: "live" }));
        })
        .finally(() => setIsClassMonitorLoading(false));
    }

    // 20260904 URL 복사 버튼 클릭 처리: 클립보드 API 우선 시도 후, 비보안/미지원 환경(사설 IP 등)은 execCommand로 대체
    const handleCopyUrl = async (url, key) => {
        if (!url) return;
        let copied = false;
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(url);
                copied = true;
            }
        } catch (error) {
            copied = false;
        }
        if (!copied) {
            try {
                const textarea = document.createElement("textarea");
                textarea.value = url;
                textarea.style.position = "fixed";
                textarea.style.top = "0";
                textarea.style.left = "0";
                textarea.style.opacity = "0";
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                copied = document.execCommand("copy");
                document.body.removeChild(textarea);
            } catch (error) {
                copied = false;
            }
        }

        // 20260906 복사 아이콘 체크 표시와 알림 메시지가 같은 시간(COPY_FEEDBACK_DURATION_MS) 후 함께 사라지게 처리
        if (alertTimerRef.current) { clearTimeout(alertTimerRef.current); alertTimerRef.current = null; }
        if (copyTimerRef.current) { clearTimeout(copyTimerRef.current); copyTimerRef.current = null; }

        if (copied) {
            setAlertKind(ConstData.ALERT_KIND.SUCCESS);
            setAlertMessage(t("URL_복사_완료", { ns: "live" }));
            setCopiedKey(key);
            copyTimerRef.current = setTimeout(() => {
                setCopiedKey(null);
                copyTimerRef.current = null;
            }, COPY_FEEDBACK_DURATION_MS);
        } else {
            setAlertKind(ConstData.ALERT_KIND.DANGER);
            setAlertMessage(t("URL_복사_실패", { ns: "live" }));
        }

        alertTimerRef.current = setTimeout(() => {
            setAlertKind(ConstData.ALERT_KIND.NONE);
            setAlertMessage("");
            alertTimerRef.current = null;
        }, COPY_FEEDBACK_DURATION_MS);
    }

    const handleSaveBroadcastLiveInfo = () => {
        if (serverUserSeq > -1) {
            if (lLiveName === "") {
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_LIVE_INFO", liveSeq: selectedLiveInfo.liveSeq, liveName: selectedLiveInfo.liveName, status: lStatus });
            } else {
                handleSelectedConfigFunc({ selectedFunc: "UPDATE_MIXED_LIVE_INFO", liveSeq: selectedLiveInfo.liveSeq, liveName: lLiveName, status: lStatus });
            }
        } else {
            handleSelectedConfigFunc({ selectedFunc: "MESSAGE", message: t("클래스_알림_메시지_7", { ns: "live" }) });
        }
    }

    const onClickModalClose = () => {
        handleSelectedConfigFunc({ selectedFunc: "MESSAGE", message: "" });
        handleSelectedConfigFunc({ selectedFunc: "NONE" });
    }

    return (
        <div className="hc-local-live-config-form" onClick={handlePreventClick}>
            <div className="title-area" style={{ color: 'white' }}>
                <span title={t("로컬_클래스_설정", { ns: "live" })}>
                    <b>{t("로컬_클래스_설정", { ns: "live" })}</b>
                </span>
                <span className="func-btn" style={{ position: 'absolute', right: '0' }} title={t("닫기", { ns: "common" })} onClick={onClickModalClose}>
                    <BsX />
                </span>
            </div>
            {/* 20260904 토글과 URL이 같은 검정 박스 안에 보이도록 전체를 하나의 박스로 감쌈 */}
            <div className="hc-local-live-settings-box">
                <div className="d-flex flex-column w-100" style={{ color: 'white' }}>
                    <div className="input-area">
                        <span className="input-label white-text pr-2 white-text small area-40" style={{ justifyContent: 'flex-start' }} title={t("믹스드_클래스", { ns: "live" })}>
                            {t("믹스드_클래스", { ns: "live" })}
                        </span>
                        <div className="input-data area-60">
                            <div className="custom-control custom-switch ml-1">
                                <input type="checkbox" className="custom-control-input" id="mixedClassStatus" /* checked={selectedLiveInfo.mixedClassExistYn === "Y" ? true : false} */ /* value={selectedLiveInfo.mixedClassExistYn === "Y" ? true : false} */ checked={lStatus} /* value={lStatus} */ onChange={onChangeMixedClassStatus} />
                                <label className="custom-control-label" htmlFor="mixedClassStatus" />
                            </div>
                        </div>
                    </div>
                    {
                        selectedLiveInfo.mixedClassUrl && selectedLiveInfo.mixedClassUrl !== "" &&
                        <div className="font-xsm plus hc-live-url-row">
                            {/* 20260904 믹스드 클래스 URL도 클릭하면 새 탭에서 열리도록 링크로 변경 */}
                            <a className="hc-live-url-link" href={selectedLiveInfo.mixedClassUrl} target="_blank" rel="noopener noreferrer">
                                {selectedLiveInfo.mixedClassUrl}
                            </a>
                            <button type="button" className="hc-live-url-copy-btn" title={t("URL_복사", { ns: "live" })} aria-label={t("URL_복사", { ns: "live" })} onClick={() => handleCopyUrl(selectedLiveInfo.mixedClassUrl, "mixed")}>
                                {copiedKey === "mixed" ? <BsClipboardCheck /> : <BsClipboard />}
                            </button>
                        </div>
                    }
                </div>
                <div className="input-area">
                    <span className="input-label white-text pr-2 small area-40" style={{ justifyContent: 'flex-start' }} title={t("클래스_공개_여부", { ns: "live" })}>
                        {t("클래스_공개_여부", { ns: "live" })}
                    </span>
                    <div className="input-data area-60">
                        <div className="custom-control custom-switch ml-1">
                            <input type="checkbox" className="custom-control-input" id="livePublicYnStatus" checked={selectedLiveInfo.livePublicYn === "Y" ? true : false} disabled={selectedLiveInfo.liveStatus === "Y" ? false : true} onChange={onChangeLivePublicYn} />
                            <label className="custom-control-label" htmlFor="livePublicYnStatus" />
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column w-100" style={{ color: 'white' }}>
                    <div className="input-area">
                        <span className="input-label white-text pr-2 small area-40" style={{ justifyContent: 'flex-start' }} title={t("클래스_모니터", { ns: "live" })}>
                            {t("클래스_모니터", { ns: "live" })}
                        </span>
                        <div className="input-data area-60">
                            <div className="custom-control custom-switch ml-1">
                                <input type="checkbox" className="custom-control-input" id="classMonitorUseStatus" checked={classMonitorUseYN === "Y"} disabled={isClassMonitorLoading || !isClassMonitorAvailable} onChange={onChangeClassMonitorUse} />
                                <label className="custom-control-label" htmlFor="classMonitorUseStatus" />
                            </div>
                            {isClassMonitorLoading && <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true" />}
                        </div>
                    </div>
                    {
                        classMonitorUseYN === "Y" &&
                        <div className="font-xsm plus hc-live-url-row">
                            <a className="hc-live-url-link" href={`${window.location.origin}/class-monitor/login`} target="_blank" rel="noopener noreferrer">
                                {`${window.location.origin}/class-monitor/login`}
                            </a>
                            <button type="button" className="hc-live-url-copy-btn" title={t("URL_복사", { ns: "live" })} aria-label={t("URL_복사", { ns: "live" })} onClick={() => handleCopyUrl(`${window.location.origin}/class-monitor/login`, "monitor")}>
                                {copiedKey === "monitor" ? <BsClipboardCheck /> : <BsClipboard />}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <Alerts kind={lAlertKind} message={lAlertMessage} style={{ marginTop: 0 }} />
        </div>
    );
}

export default ConfigLocalLive;
